import setCookieAndLoadProfile from "../utils/setCookieAndLoadProfile";
import redirectIfNotLoggedIn from "../utils/redirectIfNotLoggedIn";
import loadBasicPotluckAppData from "../utils/loadBasicPotluckAppData";
import PotluckApp from "../onsen-apps/PotluckApp";

const Search = (props) => <PotluckApp />;

Search.getInitialProps = async (context) => {
  const profile = await setCookieAndLoadProfile(context);

  if (profile) {
    return await loadBasicPotluckAppData(context);
  } else {
    redirectIfNotLoggedIn(context);
  }
};

export default Search;
